<template>

  <v-dialog
    v-model="showDialog"
    width="500"
    persistent
  >
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Import log
      </v-card-title>

      <v-card-text>
        <div :key="msg" v-for="msg in logs" class="message">
          {{ msg }}
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="show = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

import Pusher from 'pusher-js'

export default {
  props: {
    show: { required: true, type: Boolean },
    channelId: { required: false, type: String }
  },
  data() {
    return {
      logs: ["hello world"],
    }
  },

  computed: {

    showDialog () {
      return !!this.show
    },

  },

  watch: {
    channelId: {
      immediate: true,
      handler: 'subscribe'
    },
  },

  methods: {

    subscribe () {
      let pusher = new Pusher('e3297d7eb1498efae607', { cluster: 'eu' })
      pusher.subscribe('import-logs-demo')
      pusher.bind('log_added', data => {
        console.log(JSON.stringify(data)) // eslint-disable-line no-console
        this.logs.unshift(data.message)
      })
    }

  }
}

</script>
